import { Directive, Input, forwardRef } from '@angular/core';
import {
	NG_VALIDATORS,
	Validator,
	AbstractControl,
	ValidationErrors,
	FormGroup,
} from '@angular/forms';

@Directive({
	selector: '[appAtLeastOneRequired]',
	providers: [
		{
			provide: NG_VALIDATORS,
			useExisting: forwardRef(() => AtLeastOneRequiredDirective),
			multi: true,
		},
	],
	standalone: false,
})
export class AtLeastOneRequiredDirective implements Validator {
	/** Bind this via property binding:
	 *   [appAtLeastOneRequired]="['firstName','lastName','email']"
	 */
	@Input('appAtLeastOneRequired') controlNames: string[] = [];

	validate(control: AbstractControl): ValidationErrors | null {
		// Only proceed if it's a FormGroup
		if (!(control instanceof FormGroup)) {
			return null;
		}

		const hasOne = this.controlNames.some((name) => {
			const child = control.get(name);
			return (
				child != null &&
				child.value != null &&
				child.value.toString().trim() !== ''
			);
		});

		return hasOne ? null : { atLeastOneRequired: true };
	}
}
